<template>
  <v-card id="top-page" style="background-color: #eef2f5">
    <v-card class="container_main d-flex align-start justify-space-between rounded-0 bg" width="100vw"
      min-height="100vh" height="wrap-content">
      <div class="cards">
        <v-card class="banner">
          <h4>
            Hi {{ getUserInfo.name }}, CustID: {{ getUserInfo.cust_id }},
            {{ getUserInfo.cust_name }}
          </h4>
        </v-card>
        <v-card class="card_item d-flex flex-column justify-center align-center" @click="Redirect(1)"
          v-if="getPermission.case">
          <v-icon style="font-size: 2rem; color: white">{{
            "mdi-ticket"
            }}</v-icon>
          <h4 style="color: white">Cases</h4>
          <h1 style="color: white">
            {{ getHomeData.Calculated_NumberOfOpenCase }}
          </h1>
        </v-card>
        <v-card class="card_item d-flex flex-column justify-center align-center" @click="Redirect(2)"
          v-if="getPermission.call">
          <v-icon style="font-size: 2rem; color: white">{{
            "mdi-monitor-cellphone"
            }}</v-icon>
          <h4 style="color: white">Service Calls</h4>
          <h1 style="color: white">
            {{ getHomeData.Calculated_NumberOfOpenCall }}
          </h1>
        </v-card>
        <v-card class="card_item d-flex flex-column justify-center align-center" @click="Redirect(3)"
          v-if="getPermission.job">
          <v-icon style="font-size: 2rem; color: white">{{
            "mdi-calendar-month"
            }}</v-icon>
          <h4 style="color: white">Service Job Calendar</h4>
          <h1 style="color: white">{{ getHomeData.Calculated_NumberOfJob }}</h1>
        </v-card>
        <v-card class="card_item d-flex flex-column justify-center align-center" @click="Redirect(3.5)"
          v-if="getPermission.job">
          <v-icon style="font-size: 2rem; color: white">{{
            "mdi-calendar-month"
            }}</v-icon>
          <h4 style="color: white">Service Job Board</h4>
          <h1 style="color: white">{{ getHomeData.Calculated_NumberOfJob }}</h1>
        </v-card>
        <v-card class="card_item d-flex flex-column justify-center align-center" @click="Redirect(3.6)"
          v-if="getPermission.job">
          <v-icon style="font-size: 2rem; color: white">{{
            "mdi-calendar-month"
            }}</v-icon>
          <h4 style="color: white">Field Service Scheduling</h4>
          <h1 style="color: white">{{ getHomeData.Calculated_NumberOfOpenCall }}</h1>
        </v-card>
        <v-card class="card_item d-flex flex-column justify-center align-center" @click="Redirect(3.7)"
          v-if="getPermission.job">
          <v-icon style="font-size: 2rem; color: white">{{
            "mdi-calendar-month"
            }}</v-icon>
          <h4 style="color: white">Truck Schedule</h4>
          <h1 style="color: white">{{ getHomeData.Calculated_NumberOfTruck }}</h1>
        </v-card>
        <v-card class="card_item d-flex flex-column justify-center align-center" @click="Redirect(3.8)"
          v-if="getPermission.job">
          <v-icon style="font-size: 2rem; color: white">{{
            "mdi-calendar-month"
            }}</v-icon>
          <h4 style="color: white"> Booking Schedule</h4>
          <h1 style="color: white">{{ getHomeData.Calculated_NumberOfBook }}</h1>
        </v-card>
        <v-card class="card_item d-flex flex-column justify-center align-center" @click="Redirect(13)"
          v-if="getPermission.job">
          <v-icon style="font-size: 2rem; color: white">{{
            "mdi-projector-screen-variant"
            }}</v-icon>
          <h4 style="color: white">Project Jobs</h4>
          <h1 style="color: white">{{ 21 }}</h1>
        </v-card>
        <v-card class="card_item d-flex flex-column justify-center align-center" @click="Redirect(4)"
          v-if="getPermission.equipment">
          <v-icon style="font-size: 2rem; color: white">{{
            "mdi-forklift"
            }}</v-icon>
          <h4 style="color: white">Service Equipments</h4>
          <h1 style="color: white">
            {{ getHomeData.Calculated_NumberOfEquip }}
          </h1>
        </v-card>
        <v-card class="card_item d-flex flex-column justify-center align-center" @click="Redirect(5)"
          v-if="getPermission.invoice">
          <v-icon style="font-size: 2rem; color: white">{{
            "mdi-receipt-text-check-outline"
            }}</v-icon>
          <h4 style="color: white">Invoices</h4>
          <h1 style="color: white">
            {{ getHomeData.Calculated_NumberOfInvoice }}
          </h1>
        </v-card>
        <v-card class="card_item d-flex flex-column justify-center align-center" @click="Redirect(6)"
          v-if="getPermission.contract">
          <v-icon style="font-size: 2rem; color: white">{{
            "mdi-file-sign"
            }}</v-icon>
          <h4 style="color: white">Service Contracts</h4>
          <h1 style="color: white">
            {{ getHomeData.Calculated_NumberOfContract }}
          </h1>
        </v-card>
        <v-card class="card_item d-flex flex-column justify-center align-center" @click="Redirect(7)"
          v-if="getPermission.order">
          <v-icon style="font-size: 2rem; color: white">{{
            "mdi-book-open"
            }}</v-icon>
          <h4 style="color: white">Order Management</h4>
          <h1 style="color: white">
            {{ getHomeData.Calculated_OpenOrder }}
          </h1>
        </v-card>
        <v-card class="card_item d-flex flex-column justify-center align-center" @click="Redirect(8)"
          v-if="getPermission.shipment">
          <v-icon style="font-size: 2rem; color: white">{{
            "mdi-truck-fast"
            }}</v-icon>
          <h4 style="color: white">Shipment Management</h4>
          <h1 style="color: white">
            {{ getHomeData.Calculated_CountPack }}
          </h1>
        </v-card>
        <v-card class="card_item d-flex flex-column justify-center align-center" @click="Redirect(9)"
          v-if="getPermission.quote">
          <v-icon style="font-size: 2rem; color: white">{{
            "mdi-file-eye"
            }}</v-icon>
          <h4 style="color: white">Quote Management</h4>
          <h1 style="color: white">
            {{ getHomeData.Calculated_CountQuote }}
          </h1>
        </v-card>
        <v-card class="card_item d-flex flex-column justify-center align-center" @click="Redirect(10)"
          v-if="getPermission.rma">
          <v-icon style="font-size: 2rem; color: white">{{
            "mdi-glass-fragile"
            }}</v-icon>
          <h4 style="color: white">RMA Management</h4>
          <h1 style="color: white">
            {{ getHomeData.Calculated_CountRMA }}
          </h1>
        </v-card>
        <v-card class="card_item d-flex flex-column justify-center align-center" @click="Redirect(11)"
          v-if="getPermission.rma">
          <v-icon style="font-size: 2rem; color: white">{{
            "mdi-warehouse"
            }}</v-icon>
          <h4 style="color: white">Inventory Management</h4>
          <h1 style="color: white">
            {{ getHomeData.Calculated_NumberOfInventory }}
          </h1>
        </v-card>
        <v-card class="card_item d-flex flex-column justify-center align-center" @click="Redirect(12)"
          v-if="getPermission.rma">
          <v-icon style="font-size: 2rem; color: white">{{
            "mdi-message-badge"
            }}</v-icon>
          <h4 style="color: white">Memo</h4>
          <h1 style="color: white">
            {{ 0 }}
          </h1>
        </v-card>
        <v-card class="card_item d-flex flex-column justify-center align-center" @click="Redirect(14)"
          v-if="getPermission.rma">
          <v-icon style="font-size: 2rem; color: white">{{
            "mdi-account-details"
            }}</v-icon>
          <h4 style="color: white">User Management</h4>
          <h1 style="color: white">
            {{ 0 }}
          </h1>
        </v-card>
      </div>
      <!-- <div class="image_card">
        <img class="image_ad" src="https://ik.imagekit.io/v57xrgddo/MarketingBanner.png?updatedAt=1686039757282" alt="">
      </div> -->
      <div class="card_request_div_container">
        <div class="card_request_div">
          <v-expansion-panels class="card_request" multiple v-model="panel">
            <v-expansion-panel style="background-color: #eef2f5">
              <v-expansion-panel-header class="Header">Service Request</v-expansion-panel-header>
              <v-expansion-panel-content class="v-expansion-panel-content" style="height: wrap-content">
                <v-card class="pa-10 d-flex flex-column align-center justify-space-between rounded-md card" width="100%"
                  height="wrap-content">
                  <div style="width: 100%" class="d-flex flex-column align-center justify-space-between">
                    <v-text-field name="input-10-2" :label="'Name ' + '*'" color="#333333" value="" light
                      v-model="userInfo.name" class="input-group--focused" style="width: 100%" />

                    <v-text-field name="input-10-2" :label="'Email ' + '*'" v-model="userInfo.email" color="#333333"
                      value="" class="input-group--focused" style="width: 100%" />

                    <v-text-field name="input-10-2" :label="'Phone ' + '*'" v-model="userInfo.phone" color="#333333"
                      value="" class="input-group--focused" style="width: 100%" />

                    <v-text-field name="input-10-2" :label="'Company name ' + '*'" v-model="userInfo.company" value=""
                      color="#333333" class="input-group--focused" style="width: 100%" />

                    <v-text-field name="input-10-2" :label="'Equipment ID ' + '*'" v-model="userInfo.equipment"
                      color="#333333" value="" class="input-group--focused" style="width: 100%"
                      @click="showEquipmentIdDialog = true" />

                    <v-text-field name="input-10-2" :label="'Equipment Serial Number ' + '*'"
                      v-model="userInfo.equipment_serial" value="" color="#333333" class="input-group--focused"
                      style="width: 100%" @click="showEquipmentSerialDialog = true" />

                    <v-text-field name="input-10-2" :label="'Comments ' + '*'" v-model="userInfo.comment"
                      color="#333333" value="" class="input-group--focused" style="width: 100%" />
                    <div v-if="isError" class="d-flex justify-start" style="width: 100%; color: red">
                      <h5>*Please fill in all information</h5>
                    </div>
                    <div style="width: 100%" class="d-flex align-center justify-center">
                      <g-recaptcha style="width: 100%" data-sitekey="6LcEqtQlAAAAAGHpVRo-Yb6sVo0o_3fa9jT2qhoP"
                        class="input-group--focused d-flex justify-center" :data-validate="validate"
                        :data-callback="callback">
                        <v-btn elevation="2" min-width="150px" :loading="loader" :disabled="loading"
                          @click="loader = 'loading'" style="color: #1a535e; color: #1a535e"
                          class="button-submit input-group--focused">Submit Request</v-btn>
                      </g-recaptcha>
                    </div>
                  </div>
                </v-card>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
        </div>
      </div>
    </v-card>
    <v-dialog v-model="showEquipmentSerialDialog" max-width="700px">
      <v-card>
        <v-card-title>
          <span class="text-h5">#{{ this.userInfo.equipment }} Equipment Serial Number</span>
        </v-card-title>
        <v-card-text>
          <v-text-field v-model="equipmentSearch" label="Search" color="#333333" style="width: 25%"></v-text-field>
          <tableComponent :items-per-page="5" :tableHeaders="equipmentSerialHeader"
            :tableItems="getEquipmentSerialNumber" :search="equipmentSearch" parent="equipment-serial"
            @selectedEquipmentSerial="handleEquipSerialRowClick">
          </tableComponent>
        </v-card-text>
        <v-card-actions>
          <v-btn color="blue darken-1" text @click="showEquipmentSerialDialog = false">
            OK
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="showEquipmentIdDialog" max-width="700px">
      <v-card>
        <v-card-title>
          <span class="text-h5">Equipment ID</span>
        </v-card-title>
        <v-card-text>
          <v-text-field v-model="equipmentSearch" label="Search" color="#333333" style="width: 25%"></v-text-field>
          <tableComponent :items-per-page="5" :tableHeaders="equipmentHeader" :tableItems="getEquips"
            :search="equipmentSearch" parent="equipment-id" @selectedEquipmentId="handleEquipIdRowClick">
          </tableComponent>
        </v-card-text>
        <v-card-actions>
          <v-btn color="blue darken-1" text @click="showEquipmentIdDialog = false">
            OK
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-card>
</template>
<script>
import gRecaptcha from "@finpo/vue2-recaptcha-invisible";
import tableComponent from "../table/tableComponent.vue";
import { mapGetters } from "vuex";
import DecodeJWT from "../DecodeJWT";
export default {
  components: {
    gRecaptcha,
    tableComponent,
  },
  mounted() {
    let token = localStorage.getItem("token");
    if (token == "" || !token) {
      this.$router.push("/login");
    } else {
      var info = DecodeJWT(token);
      if (info.exp <= new Date().getTime() / 1000) {
        this.$router.push("/login");
      } else {
        this.$store.dispatch("User/DSPGetCompanyInfo");
        this.$store.dispatch("Data/getEquipsData");
        this.userInfo.name = this.getUserInfo.name;
        this.userInfo.email = this.getUserInfo.email;
        this.userInfo.phone = this.getUserInfo.phone;
        this.userInfo.company = this.getCustName;
        this.userInfo.company_address = this.getUserInfo.company_address;
        this.userInfo.token = this.getUserInfo.token;
        this.panel = Array.from(Array(1).keys());
        window.scrollTo({
          top: document.getElementById("top-page"),
          left: 0,
          behavior: "smooth",
        });
        this.$store.dispatch("Data/getHomeData");
      }
    }
  },
  data() {
    return {
      panel: null,
      userInfo: {
        name: "",
        email: "",
        phone: "",
        company: "",
        company_address: "",
        equipment_serial: "",
        equipment: "",
        token: "",
        comment: "",
      },
      equipmentHeader: [
        { text: "Company", value: "Equip_Company" },
        { text: "Equipment ID", value: "Equip_EquipID" },
        { text: "Equipment Description", value: "Equip_Description" },
        { text: "Inactive", value: "Equip_InActive" },
        { text: "Brand", value: "Equip_Brand" },
        { text: "Model", value: "Equip_Model" },
        { text: "In Service Date", value: "Equip_InServiceDate" },
        { text: "Serial Number", value: "Equip_SerialNum" },
        { text: "Equipment Status", value: "Equip_StatusID" },
        { text: "Warranty Expire Date", value: "Equip_WarrantyExpDate" },
      ],
      equipmentSerialHeader: [
        { text: "Company", value: "Equip_Company" },
        { text: "Equipment ID", value: "Equip_EquipID" },
        { text: "Serial Number", value: "Equip_SerialNum" },
      ],
      loading: false,
      loader: null,
      loadata: false,
      token: "",
      isError: false,
      showEquipmentSerialDialog: false,
      showEquipmentIdDialog: false,
      equipmentSearch: "",
    };
  },
  computed: {
    ...mapGetters("User", ["getUserInfo", "getPermission", "getCustName"]),
    ...mapGetters("Data", [
      "getHomeData",
      "getCaseNum",
      "getEquips",
      "getIsDone",
    ]),
    getEquipmentSerialNumber() {
      return this.getEquips
        .filter((item) => item.Equip_EquipID === this.userInfo.equipment)
        .map((item) => ({
          Equip_Company: item.Equip_Company,
          Equip_EquipID: item.Equip_EquipID,
          Equip_SerialNum: item.Equip_SerialNum,
        }));
    },
  },
  watch: {
    getCaseNum() {
      if (this.getCaseNum != "") {
        alert(
          "Thanks for your inquiry, our customer support will get in touch with you as soon as possible. Your ticket number is " +
          this.getCaseNum +
          "."
        );

        this.userInfo.comment = "";
        this.userInfo.equipment_serial = "";
        this.userInfo.equipment = "";
      }
    },
    getCustName() {
      this.userInfo.company = this.getCustName;
    },
    getIsDone() {
      if (this.getIsDone == true) {
        this.$store.dispatch("Data/setIsDoneFalse");
        this.loader = null;
      }
    },
    getUserInfo() {
      this.userInfo.name = this.getUserInfo.name;
      this.userInfo.email = this.getUserInfo.email;
      this.userInfo.phone = this.getUserInfo.phone;
      this.userInfo.company = this.getUserInfo.cust_name;
      this.userInfo.company_address = this.getUserInfo.company_address;
    },
  },
  methods: {
    handleEquipIdRowClick(item) {
      this.userInfo.equipment = item.Equip_EquipID;
      this.userInfo.equipment_serial = "";
      this.equipmentSearch = "";
      this.showEquipmentIdDialog = false;
    },
    handleEquipSerialRowClick(item) {
      this.userInfo.equipment_serial = item.Equip_SerialNum;
      this.equipmentSearch = "";
      this.showEquipmentSerialDialog = false;
    },
    Redirect(i) {
      switch (i) {
        case 1:
          this.$router.push("/case-service-request");
          break;
        case 2:
          this.$router.push("/service-calls");
          break;
        case 3:
          this.$router.push("/service-jobs");
          break;
        case 3.5:
          this.$router.push("/service-jobs1");
          break;
        case 3.6:
          this.$router.push("/fs-scheduling");
          break;
        case 3.7:
          this.$router.push("/equip-scheduling");
          break;
        case 3.8:
          this.$router.push("/booking-schedule");
          break;
        case 13:
          this.$router.push("/project-jobs");
          break;
        case 4:
          this.$router.push("/assets-equips");
          break;
        case 5:
          this.$router.push("/invoices");
          break;
        case 6:
          this.$router.push("/service-contracts");
          break;
        case 7:
          this.$router.push("/order-management");
          break;
        case 8:
          this.$router.push("/shipment-management");
          break;
        case 9:
          this.$router.push("/quote-management");
          break;
        case 10:
          this.$router.push("/rma-management");
          break;
        case 11:
          this.$router.push("/inventory-management");
          break;
        case 12:
          this.$router.push("/memo");
          break;
        case 14:
          this.$router.push("/user-management");
          break;
      }
    },
    validate() {
      return true;
    },
    async callback(token) {
      if (token) {
        if (
          this.userInfo.name != "" &&
          this.userInfo.email != "" &&
          this.userInfo.phone != "" &&
          this.userInfo.company != "" &&
          this.userInfo.equipment_serial != "" &&
          this.userInfo.equipment != ""
        ) {
          await this.$store.dispatch("Data/createRequest", {
            user: this.userInfo,
          });
          this.isError = false;
        } else {
          this.isError = true;
        }
      } else {
        alert("Please check you are not robot!!!");
      }
    },
  },
};
</script>
<style scoped lang="scss">
.v-expansion-panel--active>.v-expansion-panel-header {
  min-height: 48px;
}

.card_request_div_container {
  width: 40%;
  display: flex;
  justify-content: center;
}

.v-sheet.v-card:not(.v-sheet--outlined) {
  box-shadow: none;
}

.v-expansion-panel::before {
  box-shadow: none;
}

.v-expansion-panel-content::v-deep .v-expansion-panel-content__wrap {
  padding: 0;
}

.justify-space-between {
  justify-content: center;
}

.card_request_div {
  justify-content: center;
  align-items: center;
  width: 100%;
  margin-right: 10px;
  margin-left: 10px;
}

.card_request {
  background-color: #eef2f5;
  align-items: start;
  width: 100%;
  margin: 0 10px 0 0;
}

.banner {
  width: 100%;
  height: 48px;
  background-color: #d1dfe3;
  // color: #e9f5fd;
  color: black;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  padding-right: 20px;
  font-size: 1.2em;
  margin: 0 10px 0;
}

.cards {
  width: 60%;
  margin-top: 10px;
  min-height: auto;
  height: wrap-content;
  border: none;
  border-radius: 0%;
  display: flex;
  flex-direction: row;
  align-items: center;
  row-gap: 10px;
  column-gap: 10px;
  justify-content: center;
  align-content: flex-start;
  flex-wrap: wrap;
  box-shadow: white;
  background-color: #eef2f5;
}

.card_item {
  width: 200px;
  height: 120px;
}

.card_item:nth-child(6n + 2) {
  background-color: #f8811c !important;
  /* background-color: #0187d9; */
}

.card_item:nth-child(6n + 3) {
  background-color: #f4cb6b !important;
}

.card_item:nth-child(6n + 4) {
  background-color: #a2d183 !important;
  /* background-color: #008baa; */
}

.card_item:nth-child(6n + 5) {
  background-color: #0187d9 !important;
  /* background-color: #008baa; */
}

.card_item:nth-child(6n) {
  background-color: #008baa;
  /* background-color: #0187d9; */
}

.card_item:nth-child(6n + 1) {
  background-color: #6e7b83;
}

.card {
  background-color: rgba(255, 255, 255, 0.8);
  margin-top: 10px;
}

.button-submit {
  width: 100%;
  padding-top: 0.625rem;
  padding-bottom: 0.625rem;
  background-color: transparent;
  color: #1a535e;
  border-radius: 2em;
  border-width: 2px;
  background: 0 0;
  font-weight: bold;
  margin-top: 10px;
}

.Header {
  font-weight: 700;
  font-size: 1.2em;
  height: 20px;
  margin-top: 10px;
  background-color: #d1dfe3;
  color: black;
}

.bg {
  flex-wrap: wrap;
  background-size: cover;
  background-color: #eef2f5;
}

.hidden {
  display: none !important;
}

a:hover {
  font-weight: bolder;
}

.mb-20 {
  margin-bottom: 50px;
}

.table-custom {
  width: 100%;
  margin-top: 20px;
}

table,
th,
td {
  border: 1px solid #ddd;
  height: 50px;
  border-collapse: collapse;
}

th {
  border-bottom: 2px solid black;
}

td {
  text-align: center;
}

.input-search {
  margin-top: 5px;
  margin-bottom: 5px;
  border-style: solid;
  outline: #1a535e;
  border-width: 1px;
  border-radius: 5px;
  border-color: #ddd;
}

.image_card {
  width: 35%;
  margin: 10px 10px 0 10px;

  .image_ad {
    width: 100%;
  }
}

@media only screen and (max-width: 1000px) {
  .cards {
    width: 100%;
  }
}

.container_main {
  justify-content: center;
  height: wrap-content;

  .cards {
    @media (max-width: 1024px) {
      width: 100%;
    }
  }

  .image_card {
    @media (max-width: 1024px) {
      width: 100%;
    }
  }

  .card_request_div,
  .card_request_div_container {
    @media (max-width: 1024px) {
      width: 100%;
    }
  }

  .v-expansion-panel-header {
    min-height: 48px;
    border-radius: 4px !important;
    // box-shadow: 0px 3px 1px -2px rgba(0, 0, 0, 0.2),
    //   0px 2px 2px 0px rgba(0, 0, 0, 0.14), 0px 1px 5px 0px rgba(0, 0, 0, 0.12);
  }
}
</style>
